export type EnumUserRouteType = (typeof EnumUserRoute)[keyof typeof EnumUserRoute];

export const EnumUserRoute = {
  member: '/member' as const,

  bankAccounts: '/member/psp/bankaccounts' as const,
  bankAccountDetails: '/member/psp/bankaccounts/:id' as const,

  educationPortal: '/member/helpcenter/education' as const,
  educationPortalDetails: '/member/helpcenter/education/:id' as const,

  eWalletPage: '/member/psp/ewallet' as const,
  eWalletDetailsPage: '/member/psp/ewallet/:id' as const,
  eWalletOperationDetailsPage: '/member/psp/ewallet/operations/:id' as const,

  pspDeposit: '/member/psp/deposit' as const,

  helpCenterDocumentsPage: '/member/helpcenter/documents' as const,

  mamLinkPage: '/member/partnership/mammanager/links/:id' as const,

  masterProfilePage: '/member/socialtrading/master/:userId' as const,
  mastersRatingPage: '/member/socialtrading/mastersrating' as const,
  myInvestorsPage: '/member/socialtrading/mystatistics/statisticsdetails/followers' as const,
  myInvestorOperationHistory: '/member/socialtrading/mystatistics/statisticsdetails/followers/:id' as const,
  myMastersPage: '/member/socialtrading/mystatistics/statisticsdetails/masters' as const,
  myStatisticsPage: '/member/socialtrading/mystatistics' as const,

  cryptoWalletAccounts: '/member/psp/cryptowallets' as const,
  cryptoWalletAccountDetails: '/member/psp/cryptowallets/:id' as const,

  partnershipPage: '/member/partnership' as const,
  partnershipIBEwalletPage: '/member/partnership/ibewallet' as const,
  partnershipIBEwalletHistoryPage: '/member/partnership/ibewallet/:walletAccountId' as const,
  partnershipIBEwalletOperationDetails:
    '/member/partnership/ibewallet/:walletAccountId/operations/:operationId' as const,
  partnershipIBEwalletOperationDetailsLink: '/member/partnership/ibewallet/:walletAccountId/operations' as const,

  operationHistoryPage: '/member/socialtrading/operationhistory' as const,

  referralLinkPage: '/member/links/:id' as const,

  sales: '/member/sales' as const,
  salesUsers: '/member/sales/user' as const,
  salesUserDetails: '/member/sales/user/:id' as const,
  salesUserTradingAccounts: '/member/sales/tradingaccount' as const,
  salesUserTradingAccountDetails: '/member/sales/tradingaccount/:id' as const,
  salesUserDeposits: '/member/sales/deposit' as const,
  salesUserDepositDetails: '/member/sales/deposit/:id' as const,
  salesUserWithdrawals: '/member/sales/withdrawal' as const,
  salesUserWithdrawalDetails: '/member/sales/withdrawal/:id' as const,

  ticketPage: '/member/helpcenter/usertickets' as const,
  ticketDetailsPage: '/member/helpcenter/usertickets/:id' as const,

  tradingAccountsPage: '/member/tradingaccounts' as const,
  tradingAccountDetailsPage: '/member/tradingaccounts/:accountId' as const,
  tradingAccountHistoryPage: '/member/tradingaccounts/:accountId/history' as const,
  tradingAccountInvestorPage: '/member/tradingaccounts/:accountId/follower' as const,
  tradingAccountMasterPage: '/member/tradingaccounts/:accountId/master' as const,
  tradingAccountDepositPage: '/member/tradingaccounts/:accountId/deposit' as const,
  tradingAccountWithdrawalPage: '/member/tradingaccounts/:accountId/withdraw' as const,

  tradingContestPage: '/member/tradingcontest' as const,
  tradingContestDetails: '/member/tradingcontest/:traidingContestId' as const,

  tradingPlatforms: '/member/tradingplatforms' as const,
  tradingTools: '/member/tradingtools' as const,

  notificationsPage: '/member/notifications' as const,

  settingsPage: '/member/settings' as const,

  profilePage: '/member/profile' as const,

  pspPage: '/member/psp' as const,

  loyaltyProgramPage: '/member/loyaltyprogram' as const,
  loyaltyProgramDetailsPage: '/member/loyaltyprogram/:loyaltyProgramId' as const,
  loyaltyProgramRedeemPage: '/member/loyaltyprogram/redeem/:redeemId' as const,
  loyaltyProgramRedeemParticipantPage: '/member/loyaltyprogram/redeem/:participantRedeemId/participant' as const,
};
